import { FC, memo } from 'react';

import { Root } from './Container.styles';
import { ContainerProps } from './Container.types';

/**
 * Component dynamically adjusts its width based on the screen width.
 *
 * Screen: 1680 - ∞ | Container: 1680
 * Screen: 1280 - 1679 | Container: 1280
 * Screen: 960 - 1279 | Container: 960
 * Screen: 768 - 959 | Container: 768
 * Screen: 0 - 767 | Container: 100%
 */
export const Container: FC<ContainerProps> = memo((props) => {
    const { height, children, ...restProps } = props;

    return (
        <Root $height={height} {...restProps}>
            {children}
        </Root>
    );
});

Container.displayName = 'Container';
